var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "autocomplete" }, [
    _c("div", { ref: "output", staticClass: "output" }, [
      _c("span", { style: _vm.spanStyle })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "xy",
        staticClass: "xy",
        style: { top: _vm.xytop + "px", left: _vm.xyleft + "px" }
      },
      [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.shown,
                expression: "shown"
              }
            ],
            ref: "usernamesList",
            staticClass: "autocomplete-results"
          },
          _vm._l(_vm.shownSuggestions, function(result, i) {
            return _c(
              "li",
              {
                key: i,
                staticClass: "autocomplete-result",
                class: { "is-active": i === _vm.selectedIndex },
                on: {
                  click: function($event) {
                    return _vm.setResult(result)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(result) + "\n      ")]
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }